

























import Vue from 'vue'
import InputField from '@/components/atoms/InputField.vue'
import { MdButton, MdCard, MdField, MdLayout } from 'vue-material/dist/components'
import gql from 'graphql-tag'

Vue.use(MdButton)
Vue.use(MdCard)
Vue.use(MdField)
Vue.use(MdLayout)

export default Vue.extend({
  name: 'RegisterEmail',
  components: {
    InputField
  },
  data: () => ({
    email: ''
  }),
  methods: {
    submit: async function () {
      let request = await this.$apollo.mutate({
        mutation: gql`mutation {
          emailAvailable(
            email: "${this.email}"
          )
        }`
      })
      if (request.data.emailAvailable === true) {
        this.$emit('propagate-value', this.email, 'email')
        this.$emit('propagate-value', '', 'error')
      } else {
        this.$emit('propagate-value', this.$t('emailAddress'), 'error')
      }
    }
  }
})
